import applicationConfig from 'config/applicationConfig';

export const buildApplicationSseUrl = (submissionId: string): string => {
  const url = new URL(`${import.meta.env.VITE_BACKEND_URL}/api/submissions/${submissionId}/events`);

  url.searchParams.set('transactionId', applicationConfig.transactionId);
  url.searchParams.set('sessionId', applicationConfig.sessionId);

  return url.toString();
};
